<template>
  <div>
    <div class="is-flex is-align-items-center is-justify-content-space-between navigation_container">
      <a @click="goToNextWeek" class="button is-info">Next Week</a>
      <AdminRecruiterChooser :is-super-user="isSuperUser" :recruiter-list="recruiterList" @clicked="recruiterToggled"></AdminRecruiterChooser>
      <a @click="goToLastWeek" class="button is-info">Last Week</a>
    </div>
    <div dir="rtl" class="text_align_center">
      <p><b>{{ time_helper.getDateInput(getDateFrom()) }}</b> - <b>{{ time_helper.getDateInput(getDateTo()) }}</b></p>
    </div>
    <div class="is-flex is-justify-content-center">
      <table class="table" dir="rtl">
        <tr class="week_days">
          <th class="hour_th"></th>
          <th v-for="(data, index) in week_days" :key="index">
            <div class="date">
              <p class="week_day">יום {{ time_helper.getDayOfWeekInHebrew()[data.date.getDay()] }}</p>
              <p class="month">{{ data.date.getDate() }} ב{{ time_helper.getMonthsInHebrew()[data.date.getMonth()] }}</p>
            </div>
          </th>
        </tr>
        <div v-if="is_loading" class="is-flex is-justify-content-center loading_container">
          <div class="loading"></div>
        </div>
        <tr v-else v-for="hour in getHoursList()" :key="hour">
          <td class="hour_td">{{getFormattedHour(hour)}}</td>
          <td v-for="(week_day, index) in week_days" :key="index">
            <div class="stats_container">
              <div @click="openStat(stat)" v-for="stat in week_day.hour_stats[hour]" :key="stat.id" class="stat"
                   :class="{ applicant: stat.resource_type == 'Applicant', position: stat.resource_type == 'Position', company: stat.resource_type == 'Company',
                             offer: stat.resource_type == 'Offer', admin: stat.resource_type == 'Admin',
                             recruiter_visible: isMultipleRecruiters }">
                <p class="m-0 resource_type">{{ stat.resource_type }}</p>
                <div v-if="isMultipleRecruiters" class="recruiter" :style="{ 'background-color': getRecruiterData(stat.owner).color }">
                  <p class="m-0">{{ stat.owner }}</p>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapGetters } from 'vuex'
import TimeHelper from '@/custom/classes/time_helper.js'
import AdminRecruiterChooser from '@/components/admin/AdminRecruiterChooser'
export default {
  name: 'admin-efforts',
  data () {
    return {
      recruiters: this.$settings.get({ path: 'owners' }),
      is_loading: true,
      time_helper: new TimeHelper(),
      operations: [{ name: 'info', icon: '/info.svg' }],
      week_days: [],
      isSuperUser: this.$utils.getOwner().is_super_admin,
      selectedHash: []
    }
  },
  created: function () {
    this.init()
  },
  computed: {
    ...mapGetters('admins', ['getAdminsNames', 'adminFullList', 'currentUser']),
    recruiterList () {
      let hash = this.selectedHash
      if (hash.length === 0) {
        hash = JSON.parse(localStorage.getItem('calendar_recruiters')) || []
      }
      return this.adminFullList.map(recruiter => ({ ...recruiter, selected: hash.includes(recruiter.id) }))
    },
    getSelectedRecruiter () {
      const hash = JSON.parse(localStorage.getItem('calendar_recruiters')) || []
      let route_recruiter = this.recruiterList.filter(recruiter => hash.includes(recruiter.id)).map(recruiter => recruiter.first_name)
      if (route_recruiter.length === 0) {
        return this.$utils.getOwner().name
      }
      return route_recruiter
    },
    isMultipleRecruiters () {
      return this.getSelectedRecruiter != undefined && this.getSelectedRecruiter.length > 1
    }
  },
  methods: {
    recruiterToggled ({ action, id }) {
      switch (action) {
        case 'all':
          this.selectedHash = this.adminFullList.map(r => r.id)
          break
        case 'none':
          this.selectedHash = []
          break
        case 'toggle':
          const index = this.selectedHash.indexOf(id)
          index === -1 ? this.selectedHash.push(id) : this.selectedHash.splice(index, 1)
          break
        default:
          this.selectedHash = []
      }
      localStorage.setItem('calendar_recruiters', JSON.stringify(this.selectedHash))
      this.init()
    },
    init () {
      this.week_days = this.getWeekDays()
      this.is_loading = true
      this.$network_utils.getStats({
        owner: this.getSelectedRecruiter,
        created_by: 'Admin',
        sort: '-created_at',
        date_from: this.getDateFrom(),
        date_to: this.getDateTo()
      }).then(response => {
        this.mapCalendar(response)
        this.is_loading = false
      })
    },
    mapCalendar (stats) {
      stats.forEach(stat => {
        let date = new Date(stat.created_at)
        if (!this.week_days[date.getDay()]) {
          return
        }
        this.week_days[date.getDay()].hour_stats[date.getHours()].unshift(stat)
      })
    },
    getDateFrom () {
      if (this.$route.query.date_from) {
        return new Date(this.$route.query.date_from)
      }
      return this.time_helper.getCurrentDate().getFirstWeekDayDate()
    },
    getDateTo () {
      let date = this.getDateFrom()
      date.setDate(date.getDate() + 7)
      return date
    },
    getWeekDays () {
      let start_date = this.getDateFrom()
      let week_days = []
      for (let i = 0; i < 5; i++) {
        let date = new Date(start_date.setDate(start_date.getDate() - start_date.getDay() + i))
        week_days.push({ date, hour_stats: this.getInitHourStats() })
      }
      return week_days
    },
    getInitHourStats () {
      let hour_stats = []
      for (let i = 0; i <= 23; i++) {
        hour_stats.push([])
      }
      return hour_stats
    },
    getFormattedHour (hour) {
      let date = new Date()
      date.setHours(hour)
      date.setMinutes(0)
      return this.time_helper.getTimeInput(date)
    },
    getHoursList () {
      let hours = []
      for (let i = 8; i < 24; i++) {
        hours.push(i)
      }
      return hours
    },
    openStat (stat) {
      this.create({
        designator: 'stat-details-modal',
        component_name: 'StatResources',
        stat,
        show_details: true,
        modal_title: 'Stat'
      })
    },
    getRecruiterData (name) {
      return this.recruiterList.find(recruiter => recruiter.first_name == name)
    },
    getLastWeek () {
      if (this.$route.query.date_from == undefined) {
        return this.time_helper.getToday().getLastWeek()
      }
      return new Date(this.$route.query.date_from).getLastWeek()
    },
    getNextWeek () {
      if (this.$route.query.date_from == undefined) {
        return this.time_helper.getToday().getNextWeek()
      }
      return new Date(this.$route.query.date_from).getNextWeek()
    },
    goToLastWeek () {
      let query = { ...this.$route.query }
      query.date_from = this.getLastWeek().getFirstWeekDayDate().toUTCString()
      this.$router.push({ name: this.$route.name, query })
    },
    goToNextWeek () {
      let query = { ...this.$route.query }
      query.date_from = this.getNextWeek().getFirstWeekDayDate().toUTCString()
      this.$router.push({ name: this.$route.name, query })
    },
    ...mapMutations('modals', ['create'])
  },
  components: {
    AdminRecruiterChooser
  }
}
</script>
<style scoped>
  .table {
    margin-top: 30px;
  }
  th{
    width: calc(100% / 5);
    border-right: 1px solid rgba(0, 0, 0, 0.1);
    color: #666;
    text-align: center;
  }
  td {
    vertical-align: top;
    padding: 0.7rem;
    border-left: 1px solid rgba(0, 0, 0, 0.1);
    border-bottom: none;
  }
  tr {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
  .date {
    vertical-align: middle;
    font-size: 0.875rem;
    line-height: 1.3;
    font-family: "Poppins", sans-serif;
    font-weight: 700;
  }
  .week_day{
    color: #999;
    font-weight: 100;
  }
  .month {
    color: #555;
    font-weight: bold;
  }
  .hour_th{
    min-width: 105px;
    width: 105px;
    max-width: 105px;
  }
  .hour_td {
    color: #555;
  }
  .stat {
    text-align: center;
    cursor: pointer;
    display: inline-block;
    font-size: 12px;
    margin: 3px;
    padding: 3px 10px;
    border-radius: 30px;
    color: white;
  }
  .stat_time {
    display: none;
    font-size: 8px;
    margin-top: 1px;
  }
  .loading_container {
    position: absolute;
    width: 100%;
    margin-top: 60px;
  }
  .empty_stats_text{
    color: #333;
    margin-top: 40px;
    white-space: nowrap;
    text-align: center;
  }
  .applicant {
    background-color: #3273dc;
  }
  .position {
    background-color: #957DAD;
  }
  .company {
    background-color: #a64ca6;
  }
  .offer {
    background-color: orange;
  }
  .admin {
    color: #555;
    background-color: #ccc;
  }
  .recruiter_visible{
    padding: 0;
    border-radius: 4px;
  }
  .recruiter_visible .resource_type{
    padding: 0 10px;
  }
  .recruiter {
    position: relative;
    color: white;
    padding: 0 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    /*color: rgba(0, 0, 0, 0.6);*/
    background-color: #f2f2f2;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.2);
    font-size: 10.5px;
  }
  .navigation_container{
    margin-right: 30px;
    margin-left: 30px;
  }
</style>
